import { ErrorBoundary } from '@betterment/shared-components';

import { ContentCardView } from './components/ContentCardView';

export const PrimaryContentCard: React.FC = () => {
  return (
    <ErrorBoundary fallbackType="none">
      <ContentCardView location="accountOverviewGuide" />
    </ErrorBoundary>
  );
};
